import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const TrainingsForFellowsInTheMonth = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Trainings for fellows in the month" />
    </Box>
  );
};
